import { render, staticRenderFns } from "./ButtonGroupHeader.vue?vue&type=template&id=408fd652"
import script from "./ButtonGroupHeader.vue?vue&type=script&lang=js"
export * from "./ButtonGroupHeader.vue?vue&type=script&lang=js"
import style0 from "./ButtonGroupHeader.vue?vue&type=style&index=0&id=408fd652&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports